import { render } from "./OrdersPage.vue?vue&type=template&id=6ff6e618&scoped=true"
import script from "./OrdersPage.vue?vue&type=script&lang=js"
export * from "./OrdersPage.vue?vue&type=script&lang=js"

import "./OrdersPage.vue?vue&type=style&index=0&id=6ff6e618&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff6e618"]])

export default __exports__